var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-comp",style:(_setup.style)},[_c('SIcon',{attrs:{"icon":_vm.imageSrc,"alt":_vm.alt,"size":_vm.size}}),_c('div',{staticClass:"overlay-icon",style:(_setup.iconStyle)},[_c('SIcon',{attrs:{"icon":_vm.icon,"color":_setup.props.iconColor}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }